export const REDUCER_NAME = 'match'




// WEBPACK FOOTER //
// ./src/modules/threeshape/state/match/const.js